import Cookies from 'universal-cookie';
import AppConstants from './AppConstants';
var CryptoJS = require('crypto-js');
const cookies = new Cookies();

// Get Selected Tenant
export const getSelectedTenantDetails = tenants => {
  let evn = AppConstants.cookieEnvironment;
  let ckTenant = cookies.get(`ck_${evn}_t`);

  if (ckTenant != undefined) {
    try {
      const decrypted = CryptoJS.AES.decrypt(
        ckTenant.toString(),
        AppConstants.ckPrivateKey,
      );
      const selected_tenant_id = decrypted.toString(CryptoJS.enc.Utf8);
      const selected = tenants?.filter(tenant => tenant.id == selected_tenant_id);

      if (selected?.length) {
        return selected;
      }
    } catch (error) {
      // Fall back to the tenant marked as default when an old or malformed
      // tenant cookie cannot be decrypted.
    }
  }

  return tenants?.filter(tenant => tenant.default);
};

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
